import { render } from "./Item5.vue?vue&type=template&id=5f7f2fee"
import script from "./Item5.vue?vue&type=script&lang=ts"
export * from "./Item5.vue?vue&type=script&lang=ts"
script.render = render

export default script